import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { IDropdown, ILead } from "../../models/BaseModel";
import { Fetch, } from "../../shared/Fetch";
import { format } from "date-fns";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { Tag } from "primereact/tag";
import { Button } from "primereact/button";
import { JVDropdown } from "../../shared/JVDropdown";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

interface Iprops {
    singleData: ILead,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

interface ILeadHistory {
    id: number,
    leadId: number,
    statusId: number,
    statusName: string,
    isLeadActive: boolean,
    updatedBy: string,
    comment: string,
    createdAt: number
}
const schema = yup.object({
});


export const NoOfDevices = (props: Iprops) => {
    const [tableData, setTableData] = useState({ data: [], loading: false } as { data: ILeadHistory[], loading: boolean });
    const [renew, setRenew] = useState({ id: 0, open: false } as { id: number, open: boolean });
    const [plan, setPlan] = useState<IDropdown[]>();
    const [renewHistory, setRenewHistory] = useState({ device_ID: 0, open: false } as { device_ID: number, open: boolean });
    const [tableData1, setTableData1] = useState({ data: [], loading: false } as { data: any[], loading: boolean });

    const { control, handleSubmit, formState: { errors }, reset } = useForm<any>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    useEffect(() => {
        if (props.singleData.id && props.open) loadTableData();
    }, [props.singleData.id, props.open]);

    const loadTableData = async () => {
        console.log(props.singleData);
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`Customer/getNoOfDevices/${props.singleData.contact_ID}`, "GET", null, null, props.toast);
        if (response) {
            const data: { customerAttachDevices: ILeadHistory[] } = await response.json();
            setTableData({ data: data.customerAttachDevices, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    const loadTableData1 = async () => {
        console.log(props.singleData);
        setTableData1((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`customer/getPlanHistory${renewHistory.device_ID ? '/' + renewHistory.device_ID : ''}`, "GET", null, null, props.toast);
        if (response) {
            const data: { planHistory: ILeadHistory[] } = await response.json();
            setTableData1({ data: data.planHistory, loading: false });
        } else {
            setTableData1((prev) => ({ ...prev, loading: false, }));
        }
    }

    const loadPlan = async () => {
        const response = await Fetch("subscription_Plan/dropdown", "GET", null, null, null);
        if (response) {
            setPlan(await response.json());
        }
    }

    const createdAtBody1 = (rowData: any) => {
        return (
            <span>{rowData.created_at ? format(new Date(rowData.created_at+"Z"), 'dd/MM/yyyy hh:mm a') : '-'}</span>
        );
    }

    const expirdateAtBody1 = (rowData: any) => {
        return (
            <span>{rowData.expiryDate ? format(new Date(rowData.expiryDate), 'dd/MM/yyyy hh:mm a') : '-'}</span>
        );
    }

    const showRenewHistoryDialog = (rowData: any) => {
        setRenewHistory({ device_ID: rowData.device_ID, open: true });
    }
    
    // if plan expired then show red tag else green tag 
    const showcustomerName = (rowData: any) => {
        return (
            <>
                <Tag className="mr-2 text-lg" value={rowData.customer_Name} severity='info'></Tag>
            </>
        );
    }

    useEffect(() => {
        loadPlan();
        // loadTableData1();
    }, []);
    useEffect(() => {
        if (renewHistory.open) {
            loadTableData1();
        }
    }, [renewHistory.open]);


    const saveToDB = async (body: ILead) => {
        console.log(renew)
        const response = await Fetch(`customer${renew.id ? '/' + renew.id : ''}`, "PUT", body, null, props.toast);
        if (response) {
            const resData = await response.json();
            // setRenew({ id: 0, open: false });
            props.toast.current.show({ severity: 'success', detail: resData.message, life: 3000 });
        }
    }

    const historyOfRenew = (rowData: any) => {
        return (
            <div className="flex align-items-center justify-content-center gap-2">
                <Button icon="pi pi-history" className="p-button-sm p-button-rounded p-button-info" onClick={() => showRenewHistoryDialog(rowData)} />
            </div>
        )
    }


    function onSubmit(data: ILead) {
        console.log(data)
        saveToDB(data);
    }

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header={`No. Of Devices`} modal className="p-fluid" onHide={props.hideDialog}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    size="small" stripedRows scrollHeight="50vh"
                    value={tableData.data}
                    loading={tableData.loading}
                >
                    <Column field="customer_Name" header="Customer Name" body={showcustomerName} sortable></Column>
                    <Column field="device_Name" header="Device Name" sortable></Column>
                    <Column field="macAddress" header="Mac Address" sortable></Column>
                    {/* <Column field="created_by" header="created_by" sortable></Column> */}
                    {/* <Column field="created_at" header="created_at" sortable body={createdAtBody} ></Column> */}
                    {/* <Column field="expiry_date" header="Expiry Date" body={expirdateAtBody} sortable></Column> */}
                    {/* <Column field="" header="Action" body={historyOfRenew} sortable></Column> */}
                </DataTable>
                <ConfirmDialog />
            </Dialog>
            <Dialog visible={renew.open} style={{ width: '20vw' }} header={`Renew Device`} modal className="p-fluid" onHide={() => { setRenew({ id: 0, open: false }) }}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                    <div className="flex flex-column align-items-center justify-content-center gap-2">
                        <JVDropdown column={1} required label="Select Plan" control={control} options={plan} optionLabel="plan_Name" optionValue="id" name="plan_ID" placeholder="Select Status" />
                        <Button label="Renew" icon="pi pi-check" className="p-button-success" />
                    </div>
                </form>
            </Dialog>
            <Dialog visible={renewHistory.open} style={{ width: '60vw' }} header={`History`} modal className="p-fluid" onHide={() => { setRenewHistory({ device_ID: 0, open: false }) }}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    size="small" stripedRows scrollHeight="50vh"
                    value={tableData1.data}
                    loading={tableData1.loading}
                >
                    <Column field="plan_Name" header="Device Name" sortable></Column>
                    <Column field="plan_Duration" header="Duration" sortable></Column>
                    <Column field="plan_Cost" header="Cost" sortable></Column>

                    <Column field="created_at" header="Plan Date"  body={createdAtBody1} sortable></Column>
                    <Column field="expiryDate" header="Expiry Date" body={expirdateAtBody1} sortable></Column>
                </DataTable>
            </Dialog>


        </>
    );
}
